import React, { createContext, useContext, useState } from 'react';

const AgenticAIContext = createContext();

export const AgenticAIProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isMaximized, setIsMaximized] = useState(false);
    return (
        <AgenticAIContext.Provider value={{
            isOpen,
            isMaximized,
            openDrawer: () => setIsOpen(true),
            closeDrawer: () => { setIsOpen(false); setIsMaximized(false); },
            toggleMaximize: () => setIsMaximized(prev => !prev),
        }}>
            {children}
        </AgenticAIContext.Provider>
    );
};

export const useAgenticAI = () => useContext(AgenticAIContext);
